'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SearchProbe = require('./components/SearchProbe.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SearchProbe).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/probes/lib/components/search-probe/index.js
// module id = 540
// module chunks = 1